import { Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { combineLatest, Observable } from "rxjs";
import { GiftType } from "../../../shared/enums";
import { map } from "rxjs/operators";
import { ManagerService } from "../../../core/services/manager.service";
import { DataManagerService } from "../../../core/services/data-manager.service";
import { NotificationsService } from "../../../core/notifications/notifications.service";
import { DOCUMENT, isPlatformBrowser } from "@angular/common";
import { User } from "../../../shared/models/user";

@Component({
  selector: "app-refer-a-friend",
  templateUrl: "./refer-a-friend.component.html",
  styleUrls: ["./refer-a-friend.component.scss"],
})
export class ReferAFriendComponent implements OnInit {
  rafBonuses$: Observable<any[]>;
  gifts$: Observable<any[]>;
  refferralLink: string;

  constructor(
    private dialogRef: MatDialogRef<ReferAFriendComponent>,
    private managerService: ManagerService,
    private dataManager: DataManagerService,
    private notificationsService: NotificationsService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(MAT_DIALOG_DATA) public data: User
  ) {}

  ngOnInit(): void {
    this.gifts$ = this.managerService.gifts$.pipe(
      map((data) =>
        data.filter((el) => el.Currency > -1 && el.AmountTotal > 0),
      ),
    );
    this.rafBonuses$ = combineLatest(
      this.gifts$,
      this.managerService.rafBonuses$,
    ).pipe(
      map(([gifts, rafBonuses]) => {
        const arr1 = gifts.filter(
          (el) => el.Type === GiftType.ReferAFriendRegister,
        );

        const arr2 = rafBonuses;

        return [...arr1, ...arr2];
      }),
    );

    if (isPlatformBrowser(this.platformId)) {
      const loc = this.document.location;
      console.log(loc.href, "location");
      const host = new URL(loc.href).hostname;
      const customerURL = host.replace(/^[^.]+\./, "") + "/";
      this.refferralLink = `https://registration.${customerURL}?referral=${this.data?.memberProfile?.Username}`;
    }
  }

  close() {
    this.dialogRef.close();
  }

  unlock(gift: any) {
    if (
      !gift.Type &&
      gift.Type !== GiftType.RakeBack &&
      gift.Type !== GiftType.DepositBonus &&
      gift.Type !== GiftType.SignupBonus &&
      gift.Type !== GiftType.RakeBack &&
      (gift?.Progress < 100 || gift?.ReferrerGift?.Progress < 100)
    ) {
      return;
    } else if (
      gift.Type !== GiftType.RakeBack &&
      (gift.Type !== GiftType.DepositBonus ||
        gift.Type !== GiftType.SignupBonus) &&
      gift?.Progress === 0
    ) {
      return;
    }
    this.dataManager.unlockGift(
      gift.ReferrerGift ? gift.ReferrerGift.Id : gift.Id,
    );
  }
  generateReferral() {
    this.notificationsService.showSuccess("Referral link copied to clipboard");
  }
}
